import ConfirmDialog from "components/ConfirmDialog"
import PageLoader from "components/PageLoader"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { getTintVTOService } from "services/tintvto"
import {
  BaseHeaderLayout,
  Box,
  ContentLayout,
  Flex,
  IconButton,
  LinkButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Typography,
} from "@strapi/design-system"
import { Pencil, Plus, Trash } from "@strapi/icons"
import { useAlert } from "providers/AlertProvider"

export const UsersPage = () => {
  const navigate = useNavigate()
  const service = getTintVTOService()
  const [users, setUsers] = useState([])
  const [isLoading, setLoading] = useState(false)
  const { t } = useTranslation()
  const [userToDelete, setUserToDelete] = useState(null)
  const userDetails = service.userDetails()

  const updateUsers = useCallback(async () => {
    setLoading(true)
    const {
      data: { listUsers },
    } = await service.listUsers()
    setUsers(listUsers)
    setLoading(false)
  }, [service])

  useEffect(() => {
    void updateUsers()
  }, [updateUsers])
  const { showAlert } = useAlert()
  return (
    <>
      <ConfirmDialog
        isOpen={!!userToDelete}
        onClose={() => setUserToDelete(null)}
        onConfirm={async () => {
          await service.deleteUser(userToDelete)
          setUserToDelete(null)
          showAlert({
            error: false,
            text: t("usersPage.userDeleted", { username: userToDelete }),
          })
          await updateUsers()
        }}
        text={t("usersPage.deleteConfirmation", { username: userToDelete })}
      />
      <Box>
        <BaseHeaderLayout
          title={t("usersPage.title")}
          as={"h1"}
          primaryAction={
            <LinkButton startIcon={<Plus />} target="_self" href={`/users/add`}>
              {t("usersPage.addUser")}
            </LinkButton>
          }
          subtitle={t("usersPage.usersFound", { count: users ? users.length : 0 })}
        />
        {!!users.length && (
          <ContentLayout>
            <Table>
              <Thead>
                <Tr>
                  <Th>{t("usersPage.username")}</Th>
                  <Th>{t("usersPage.sub")}</Th>
                  <Th>{t("usersPage.groups")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {users.map((user) => (
                  <Tr key={user.sub}>
                    <Td>
                      <Typography textColor="neutral800">{user.username}</Typography>
                    </Td>
                    <Td>{user.sub}</Td>
                    <Td>{user?.groups?.join()}</Td>
                    <Td>
                      <Flex gap={2}>
                        {userDetails.username !== user.username && (
                          <IconButton
                            onClick={() => setUserToDelete(user.username)}
                            label={t("usersPage.delete")}
                            icon={<Trash />}
                          />
                        )}
                        <IconButton
                          onClick={() =>
                            navigate(
                              `/users/edit?username=${user.username}&group=${user.groups[0]}`
                            )
                          }
                          label={t("usersPage.edit")}
                          icon={<Pencil />}
                        />
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ContentLayout>
        )}
        {isLoading && <PageLoader />}
      </Box>
    </>
  )
}
